/* ---- Product page behaviour ---- */
(() => {
  'use strict';
  // Variant changes (price, button, URL, media, quantity rules) are handled by <product-info> in product-info.js.

  if (!customElements.get('quantity-input')) customElements.define('quantity-input', class extends HTMLElement {
    connectedCallback() {
      if (this.input) return;
      this.input = this.querySelector('input');
      if (!this.input) return;
      this.minus = this.querySelector('[data-minus]');
      this.plus = this.querySelector('[data-plus]');
      this.minus?.addEventListener('click', () => this.step(-1));
      this.plus?.addEventListener('click', () => this.step(1));
      this.input.addEventListener('change', () => this.commit());
    }

    rules() { return window.theme.quantityRules(this.input); }

    // Work out the next value first and only then write it, so the field never shows more than the maximum.
    step(direction) {
      const rules = this.rules();
      const next = window.theme.clampQuantity(this.input.value, rules).value + direction * rules.step;
      if (next > rules.max || next < rules.min) {
        if (next > rules.max || rules.min > 1) window.theme.toast(window.theme.quantityMessage(next > rules.max ? 'max' : 'min', rules));
        return;
      }
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Snap a typed (or variant-changed) value to min / increment / max; say why unless silent.
    commit(silent = false) {
      const rules = this.rules();
      const empty = this.input.value.trim() === '';
      const { value, reason } = window.theme.clampQuantity(empty ? rules.min : this.input.value, rules);
      if (String(value) !== this.input.value) this.input.value = value;
      if (reason && !silent && !empty) window.theme.toast(window.theme.quantityMessage(reason, rules));
    }
  });

  if (!customElements.get('product-form')) customElements.define('product-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form'); if (!this.form) return;
      this.form.addEventListener('submit', (e) => this.submit(e));
    }
    async submit(e) {
      e.preventDefault();
      const btn = this.form.querySelector('[data-add-button]'); const err = this.querySelector('[data-form-error]');
      if (btn?.disabled || btn?.getAttribute('aria-busy') === 'true') return;
      btn?.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
      try {
        this.form.querySelector('quantity-input')?.commit?.();
        const fd = new FormData(this.form);
        const id = fd.get('id');
        if (!id) return;
        const line = { id: Number(id), quantity: Number(fd.get('quantity')) || 1 };
        if (fd.get('selling_plan')) line.selling_plan = Number(fd.get('selling_plan'));
        const properties = {};
        for (const [key, value] of fd) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) line.properties = properties;

        const added = await window.theme.cart.add([line], { opener: btn });
        if (!added) { if (err) { err.textContent = window.theme.cart.lastError || (window.theme.strings?.cartError ?? ''); err.hidden = !err.textContent; } return; }
        const delay = window.theme.addedDelay ?? 700;
        btn?.classList.add('is-added');
        setTimeout(() => btn?.classList.remove('is-added'), delay + 700);
        if (window.theme.cartType !== 'drawer') setTimeout(() => { location.href = `${window.Shopify?.routes?.root || '/'}cart`; }, delay);
        else { const modal = this.closest('ft-modal'); setTimeout(() => modal?.close?.(), delay); }
      } catch (error) {
        if (err) { err.textContent = window.theme.strings?.cartError || ''; err.hidden = false; }
      } finally { btn?.removeAttribute('aria-busy'); }
    }
  });

  if (!customElements.get('pickup-availability')) customElements.define('pickup-availability', class extends HTMLElement {
    connectedCallback() { this.update(this.dataset.variantId); }
    async update(variantId) {
      if (!variantId) return;
      try {
        const html = await (await fetch(`${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-pickup]');
        this.innerHTML = ''; if (content) this.appendChild(content);
      } catch {}
    }
  });
})();
